import React from 'react';
import Welcome from '../components/welcome/Welcome';
import '../styles/welcome-page.css';

const WelcomePage = ({history}) => {
    return (
      <Welcome history ={history} />
  );
};

export default WelcomePage;



// WEBPACK FOOTER //
// ./src/containers/WelcomePage.js